@media screen and (max-width: 979px) {
  .action-blocks {
    padding: 24px 8px;
  }
}

.action-blocks__item {
  display: block;
}

@media screen and (max-width: 979px) {
  .action-blocks__item {
    margin-bottom: 12px;
  }
}